/* Coria · GSAP gol pentru telefon (comutator cf_speed4).
   Pe ecrane sub 750px nu se mai incarca gsap, ScrollTrigger si SplitText (~100 KB si mult lucru pe procesor).
   Tema le cheama in multe locuri, asa ca aici sunt inlocuite cu functii care nu fac nimic:
   elementele raman vizibile, doar fara animatiile de intrare. */
(function () {
  var noop = function () {};
  function chain() {
    var t = {};
    ['to', 'from', 'fromTo', 'set', 'add', 'call', 'play', 'pause', 'kill', 'reverse', 'restart', 'progress', 'eventCallback',
     'delay', 'duration', 'addLabel', 'seek', 'clear', 'timeScale', 'totalProgress', 'invalidate', 'paused', 'reversed', 'then', 'revert']
      .forEach(function (k) { t[k] = function () { return t; }; });
    t.isActive = function () { return false; };
    return t;
  }
  function mm() {
    return {
      add: function (q, fn) {
        try { if (typeof q === 'string' && window.matchMedia(q).matches && fn) fn({ conditions: {} }); } catch (e) {}
        return this;
      },
      revert: noop, kill: noop
    };
  }
  window.gsap = {
    registerPlugin: noop, set: noop, to: chain, from: chain, fromTo: chain, timeline: chain, matchMedia: mm,
    killTweensOf: noop, getProperty: function () { return 0; }, defaults: noop, config: noop,
    ticker: { add: noop, remove: noop }, context: function (fn) { try { fn && fn(); } catch (e) {} return { revert: noop }; },
    utils: {
      random: function (a) { return a; },
      toArray: function (x) { return !x ? [] : typeof x === 'string' ? [].slice.call(document.querySelectorAll(x)) : x.length !== undefined ? [].slice.call(x) : [x]; }
    }
  };
  window.ScrollTrigger = {
    create: function () { return { kill: noop, refresh: noop, disable: noop, enable: noop, progress: 0 }; },
    batch: function () { return []; }, getById: function () { return null; }, getAll: function () { return []; },
    refresh: noop, sort: noop, update: noop, killAll: noop, config: noop, defaults: noop, matchMedia: noop,
    addEventListener: noop, removeEventListener: noop, scrollerProxy: noop, normalizeScroll: noop
  };
  window.SplitText = function () { this.chars = []; this.words = []; this.lines = []; this.elements = []; this.revert = noop; };
  window.CF_GSAP_LITE = true;
})();
